import React from 'react';

const AboutPage = () => {
    return (
        <div>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae blanditiis deleniti illum molestiae mollitia recusandae ullam vel voluptatem. Accusamus asperiores aspernatur autem ducimus fugiat impedit in laboriosam libero, modi nam non nulla, officia quibusdam tempora ut, vel voluptate! Ad blanditiis dolor dolorem ex minima nesciunt pariatur quod repellat sunt, veritatis.
        </div>
    );
};

export default AboutPage;